if (!customElements.get('authors-slider')) {
  class AuthorsSlider extends HTMLElement {
    #bound = false;

    connectedCallback() {
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          (entries) => {
            if (entries[0].isIntersecting) {
              io.disconnect();
              this.#init();
            }
          },
          { rootMargin: '300px' }
        );
        io.observe(this);
      } else {
        this.#init();
      }
    }

    #init() {
      const swiperEl = this.querySelector('swiper-container');
      const prevBtn = this.querySelector('[data-authors-prev]');
      const nextBtn = this.querySelector('[data-authors-next]');

      if (!swiperEl) return;

      const updateButtons = () => {
        const swiper = swiperEl.swiper;
        if (!swiper) return;

        // 1. Logic for Beginning
        const isBeginning = swiper.isBeginning;

        // 2. Logic for End (Optimized for autoWidth)
        // We check swiper.isEnd, but also swiper.progress.
        // progress >= 1 means the slider cannot move further right.
        // We use 0.99 to account for sub-pixel rounding errors in autoWidth.
        const isEnd = swiper.isEnd || swiper.progress >= 0.99 || swiper.isLocked;

        if (prevBtn) prevBtn.disabled = isBeginning;
        if (nextBtn) nextBtn.disabled = isEnd;
      };

      const bind = () => {
        if (this.#bound) return;
        const swiper = swiperEl.swiper;

        // Force disable looping features that cause "infinity"
        swiper.params.loop = false;
        swiper.params.rewind = false;

        prevBtn?.addEventListener('click', () => swiper.slidePrev());
        nextBtn?.addEventListener('click', () => swiper.slideNext());

        // Events that matter for autoWidth and resizing
        const events = [
          'slideChange',
          'progress',      // Essential for autoWidth
          'resize',        // Updates when window grows/shrinks
          'breakpoint',    // Updates on screen changes
          'update'         // Catch-all for layout changes
        ];

        events.forEach(evt => swiper.on(evt, updateButtons));

        // Initial check
        updateButtons();
        this.#bound = true;
      };

      if (swiperEl.swiper) {
        bind();
      } else {
        // Support both standard and component-specific init events
        swiperEl.addEventListener('swiperinit', bind, { once: true });
        swiperEl.addEventListener('swiperafterinit', bind, { once: true });
      }
    }
  }

  customElements.define('authors-slider', AuthorsSlider);
}